import { render } from "./TemplateInfoItem.vue?vue&type=template&id=6bc05601"
import script from "./TemplateInfoItem.vue?vue&type=script&lang=js"
export * from "./TemplateInfoItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/alangray/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__